<template>
  <div>
    <PageTitleVue class="uppercase" :subTitle="'Horario atual: ' + currentTime ">
      Registro de ponto
    </PageTitleVue>

    <Form :descriptionTitle="'Faça o registro de seus horarios'">
      <div class="w-full flex justify-center">
        <CreateButton
          @click="ponto"
          :icon="PhTimer"
          :label="'Registrar'"
        />
      </div>
    </Form>
  </div>
</template>

<script setup>
import PontoService from '../services/ponto.service'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from './Form.vue'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { useGeolocation } from '@/composable/useGeolocation'
import { showToast as toast } from '@/helpers/UseToasts'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { PhTimer } from '@phosphor-icons/vue'
import { dataPonto } from '../store'
import { storeApp } from '@/store'
import * as yup from '../../../validator'
import afastamService from '@/modules/afastamento/services/afastam.service'

const { latitude, longitude, getLocation, error } = useGeolocation();

let permissions = localStorage.getItem('__permissions')
let permissionArray = permissions?.split(',');
const registerToCollab = ref(
  permissionArray.includes('pon_to_coll')
)

const appStore = storeApp.state
const store = dataPonto

const currentTime = ref(new Date().toLocaleTimeString())
const interval = ref(null)

const updateClock = () => {
  currentTime.value = new Date().toLocaleTimeString();
}

const schema = yup.object().shape({
  type: yup.string().required('É necessário informar o tipo').label('Tipo')
})

async function ponto () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = (await validateFormField(schema, store.state))

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  if(! registerToCollab.value)
    store.state.user_id = localStorage.getItem('__uuid')
  
  const data = store.state

  delete data.user

  data.latitude = latitude
  data.longitude = longitude

  await PontoService.register(data)
    .then((res) => {
      appStore.loading = false

      if (res.data.info) {
        return toast(
          'Protege informa: ',
          res.data.message,
          'info'
        )
      }

      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    }).catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error || err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar horario',
        'error'
      )
    })
}

async function getCollabCombo() {
  await afastamService.getAllCollabs()
    .then(res => {
      store.dispatch('setCollabsCombo', res.data);
    }).catch(err => {
      console.log(err);
    })
}

onMounted(() => {
  store.commit('reset')
  store.state.user = localStorage.getItem('__user_name')
  
  getLocation()
  
  if(registerToCollab) {
    Promise.all([
      getCollabCombo()
    ])
  }

  interval.value = setInterval(updateClock, 1000);
  console.log(error);
})

onBeforeUnmount(() => {
  clearInterval(interval);
})
</script>
